import "@root/style.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "@root/App";
import { BrowserRouter as Router } from 'react-router-dom';
import { sunboundPayProxy } from '@proxies';
import { SpinnerProvider, SessionProvider, SettingsProvider } from '@common';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: `https://5c37fb4f0561a28f1fabca14e8fe8740@o4508608607879168.ingest.us.sentry.io/4508614478856192`,
  environment: window.settings.ENV
});

sunboundPayProxy.init(window.settings.SUNBOUNDPAY_API);

const Navigation = () => (

    <SettingsProvider>
        <SessionProvider>
            <SpinnerProvider>
                <Router>
                    <App />
                </Router>
            </SpinnerProvider>
        </SessionProvider>
    </SettingsProvider>
);

const container = document.getElementById(`root`);
if (container !== null) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <Navigation />
    </React.StrictMode>
  );
} else {
  console.error(`Failed to find the root element`);
}

